import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/contao': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M45.4 305c14.4 67.1 26.4 129 68.2 175h-79.6c-18.7 0-34-15.2-34-34v-380c0-18.7 15.2-34 34-34h57.7c-13.8 12.6-26.1 27.2-36.9 43.6-45.4 70-27 146.8-9.4 229.4zM478 32c18.8 0 34 15.2 34 34v380.1c0 18.8-15.3 34-34 34h-52.1c38.7-38.4 60.6-92.1 57.4-163.6l-137.4 29.6c-1.7 32.5-12.9 63.8-57.4 73.2-24.9 5.3-45.4-0.6-58.3-11.7-15.8-13.5-28.4-31-49.5-131.2-21.4-100.5-17-121.6-8.2-140.3 7.3-15.3 23.7-29.3 48.3-34.6 44.8-9.4 67.7 14.9 82.6 43.9l137.1-29.3c-13.5-34.6-31.3-62.7-52.7-84.1h90.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/contao.js
// module id = 761
// module chunks = 0